import React, { useEffect } from 'react';
import { MutationStatus } from 'react-query';
import { UploadedFile } from 'web-library/models/UploadedFile';

interface IUseSetUploadButtonStatus {
  files: UploadedFile[];
  setApiButtonStatus: React.Dispatch<React.SetStateAction<MutationStatus>>;
  setShouldSubmit: React.Dispatch<React.SetStateAction<boolean>>;
  shouldSubmit: boolean;
  onSuccessCallback: () => void;
}

const useSetUploadButtonStatus = ({
  files,
  setApiButtonStatus,
  setShouldSubmit,
  shouldSubmit,
  onSuccessCallback,
}: IUseSetUploadButtonStatus) => {
  useEffect(() => {
    const isUploading = files.some((file) => file.pending === true);
    const isUploaded = files.every((file) => file.uploaded);
    const hasError = files.some((file) => file.hasError === true);
    switch (true) {
      case isUploading:
        setApiButtonStatus('loading');
        break;
      case hasError:
        setShouldSubmit(false);
        setApiButtonStatus('idle');
        break;
      case files.length > 0 && isUploaded && shouldSubmit:
        onSuccessCallback();
        break;
      default:
        setApiButtonStatus('idle');
        break;
    }
  }, [files, shouldSubmit, onSuccessCallback, setShouldSubmit, setApiButtonStatus]);
  return null;
};

export default useSetUploadButtonStatus;
